











































import VueOptions from '@utils/VueOptions'

path = 'https://autocomplete.clearbit.com/v1/companies/suggest'

settings =
  name: 'BrandSelector'

  vue:
    props: ['value', 'disabled']

    data: ->
      sponsor: @value || {}
      search: ''

    computed:
      placeholderLogo: -> '@assets/recess-logo.png'
      hasSponsorSelected: ->
        @sponsor?.domain?.length > 0 || @sponsor?.name?.length > 0

    methods:
      hiSelect: (brand) ->
        @sponsor = brand
        @$emit 'input', brand

      hiSearch: (text, cb) ->
        results = await @searchLogos(text)
        cb(results)

      searchLogos: (text) ->
        return [] unless text?.trim().length
        response = await fetch("#{path}?query=#{text}")
        results = await response.json()
        results ||= []
        results

export default VueOptions.vue settings
